import React, { useCallback, useEffect, useRef, useState } from 'react';
import Slab from '../../../../helpers/slab/Slab';
import Details from './Details';
import Summary from './Summary';
import Get from '../../../../api/internal/Get';

function Truck({ datId }: { datId: number }) {
  const [currentPage, setCurrentPage] = useState<string>('Summary');
  const [options, setOptions] = useState<CreateDATTruckPostOptions | null>(
    null,
  );
  const [datTruckPost, setDATTruckPost] =
    useState<DATTruckPostBoardItem | null>(null);

  const hasInitialized = useRef(false);

  const GetDATTruckPost = useCallback(() => {
    Get(`/DatService/GetDatTruckPost/${datId}`).then(response => {
      if (response) {
        setDATTruckPost(response.data);
      }
    });
  }, [datId]);

  const HandlePageChange = useCallback(
    (page: string) => {
      if (page !== currentPage) {
        if (page === 'Details' && options === null) {
          Get(`/DatService/GetCreateDatTruckPost`).then(response => {
            if (response) {
              setOptions(response.data);
            }
            setCurrentPage(page);
          });
        } else {
          setCurrentPage(page);
        }
      }
    },
    [currentPage, options],
  );

  useEffect(() => {
    // Run only once (on mount)
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      GetDATTruckPost();
      HandlePageChange('Summary');
    }
  }, [GetDATTruckPost, HandlePageChange]);

  let pages = {};
  AssignPages();
  function AssignPages() {
    pages = {
      Summary: {
        content: <Summary data={datTruckPost} />,
      },
      Details: {
        content: (
          <Details
            data={datTruckPost}
            datId={datId}
            options={options}
            RefreshPage={HandlePageChange}
            GetDATTruckPost={GetDATTruckPost}
          />
        ),
      },
    };
  }

  return (
    <Slab
      title={
        datTruckPost
          ? `${datTruckPost?.datEquipmentName ?? ''}${
              datTruckPost?.length ? ` ${datTruckPost.length}ft` : ''
            } ${datId}`
          : ''
      }
      pages={pages}
      currentPage={currentPage}
      HandlePageChange={HandlePageChange}
      dataObject={{}}
    />
  );
}

export default Truck;
